(() => {
  const activate = (tab) => {
    if (!tab || tab.classList.contains('is-active')) return;
    const wrapper = tab.closest('[data-mega-tabs]');
    if (!wrapper) return;

    wrapper.querySelectorAll('.mega-tabs__tab').forEach((item) => {
      const isCurrent = item === tab;
      item.classList.toggle('is-active', isCurrent);
      item.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });

    const panelId = tab.getAttribute('aria-controls');
    wrapper.querySelectorAll('.mega-tabs__panel').forEach((panel) => {
      panel.classList.toggle('d-none', panel.id !== panelId);
    });
  };

  const onTabEvent = (event) => {
    const tab = event.target.closest && event.target.closest('.mega-tabs__tab');
    if (tab) activate(tab);
  };

  document.addEventListener('mouseover', onTabEvent);
  document.addEventListener('focusin', onTabEvent);
})();
